// extracted by mini-css-extract-plugin
export default {"root":"zS1lp"};